type Context = 'integration';

type IntegrationType = 'hubspot';

type Section =
  | 'company-mappings'
  | 'contact-mappings'
  | 'owners'
  | 'owner-mappings'
  | 'fbl-fields'
  | 'fields'
  | 'field-mappings'
  | 'lists'
  | 'settings';

type Value = `${Context}-${IntegrationType}-${Section}`;

export const Keys: Record<Section, Value> = {
  'company-mappings': 'integration-hubspot-company-mappings',
  'contact-mappings': 'integration-hubspot-contact-mappings',
  owners: 'integration-hubspot-owners',
  'owner-mappings': 'integration-hubspot-owner-mappings',
  'fbl-fields': 'integration-hubspot-fbl-fields',
  fields: 'integration-hubspot-fields',
  'field-mappings': 'integration-hubspot-field-mappings',
  lists: 'integration-hubspot-lists',
  settings: 'integration-hubspot-settings',
};
